const ACCORDION_TRANSITION_MS = 200
const MAX_SETTLE_WAIT_MS = 800
const DESKTOP_FIXED_HEADER_HEIGHT = 62
const DESKTOP_MIN_WIDTH = 1024

// Scrolls an element below the fixed desktop header, but waits until the surrounding
// accordion transition has stopped moving it - scrolling mid-collapse lands in the wrong place.
export const scrollToElementAfterLayoutSettles = (elementId: string, spacingAbove = 16): void => {
  const startedAt = performance.now()
  let previousTop: number | null = null

  const scrollWhenStable = (): void => {
    const element = document.getElementById(elementId)
    if (!element) return

    const { top } = element.getBoundingClientRect()
    const elapsed = performance.now() - startedAt
    const delta = previousTop === null ? null : top - previousTop
    const hasStoppedMoving = delta !== null && Math.abs(delta) < 1

    previousTop = top

    if ((elapsed < ACCORDION_TRANSITION_MS || !hasStoppedMoving) && elapsed < MAX_SETTLE_WAIT_MS) {
      requestAnimationFrame(scrollWhenStable)
      return
    }

    const headerOffset = window.innerWidth >= DESKTOP_MIN_WIDTH ? DESKTOP_FIXED_HEADER_HEIGHT : 0
    const targetScrollY = Math.max(0, window.scrollY + top - headerOffset - spacingAbove)

    window.scrollTo({ behavior: 'instant', top: targetScrollY })
  }

  requestAnimationFrame(scrollWhenStable)
}

export const scrollToCallback = (offset: number, callback: () => void): void => {
  const tolerance = 2 // Pixels of tolerance, to account for fractional differences

  const currentY = window.scrollY
  if (Math.abs(currentY - offset) <= tolerance) {
    callback()
    return
  }

  const onScroll = function () {
    const currentY = window.scrollY
    if (Math.abs(currentY - offset) <= tolerance) {
      window.removeEventListener('scroll', onScroll)
      callback()
    }
  }

  window.addEventListener('scroll', onScroll)

  // Trigger the smooth scroll
  window.scrollTo({
    behavior: 'smooth',
    top: offset,
  })
}
